import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { UserPreferences } from '../db/UserPreferences.js';
import { getCurrentUserID } from './currentUserID.js';

export const getMyUserPreferences = registerQuery({
  type: () => UserPreferences,
  operationName: 'getMyUserPreferences',
  resolve: () => {
    return async (_gqlFields: BaseQLSelectionSet<UserPreferences>) => {
      const userID = getCurrentUserID();
      if (!userID) return null;
      const collection = await getRawCollection<UserPreferences>(UserPreferences._collectionName);
      return (await collection.findOne<UserPreferences>({ userID })) ?? null;
    };
  },
  params: [],
});
